module.exports = __webpack_public_path__ + "img/2910059.5cfb3e42.png";